import { Box, Flex, Text } from "flicket-ui";
import CommonImage from "~components/common/Image";
import { ExtendedFile } from "~graphql/sdk";

interface CTAContentProps {
  title?: React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
}

function CTAContent(props: CTAContentProps) {
  const { title, footer = null, children } = props;

  const showFooterAsText = typeof footer === "string";

  return (
    <Flex style={{ gap: "32px" }} flexDirection={"column"} padding={4}>
      {title ? (
        <Text
          color="N800"
          fontSize={6}
          fontWeight={"extraBold"}
          textAlign={"center"}
        >
          {title}
        </Text>
      ) : null}

      {children}

      {showFooterAsText ? (
        <Text color="N700" fontWeight={"regular"} fontSize={2}>
          {footer}
        </Text>
      ) : null}

      {!showFooterAsText ? footer : null}
    </Flex>
  );
}

interface CTACardWithImageProps extends CTAContentProps {
  image?: ExtendedFile;
  imageAlt?: string;
}

export function CTACardWithImage(props: CTACardWithImageProps) {
  const { image, imageAlt, children, ...rest } = props;
  return (
    <Box>
      {props.image ? <CommonImage image={image} alt={imageAlt ?? ""} /> : null}
      <CTAContent {...rest}>{children}</CTAContent>
    </Box>
  );
}

function EventCard(props: { children: React.ReactNode }) {
  const { children } = props;
  return (
    <Box borderRadius={"sm"} boxShadow={"container"} overflow="hidden">
      {children}
    </Box>
  );
}

export default function EventCTACard(props: CTACardWithImageProps) {
  return (
    <EventCard>
      <CTACardWithImage {...props} />
    </EventCard>
  );
}
